// extracted by mini-css-extract-plugin
export default {"nextTeam":"styles_nextTeam__wiKrU","usersListItem":"styles_usersListItem__6vKKq"};